class ProductModal extends HTMLElement {
  constructor() {
    super();
    this.closeTriggers = this.querySelectorAll('[data-close]');
    this.openTriggers = document.querySelectorAll('[data-trigger="product-modal"]');
		this.productInput = this.querySelector('#product');
    this.init();
  }

  handleClose() {
    if(!this.closeTriggers?.length) return;

    this.closeTriggers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        document.querySelector('html').style.overflow = "";
        this.classList.add('closed');
      });
    });
  }

  handleOpen() {
    if(!this.openTriggers?.length) return;



    this.openTriggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        document.querySelector('html').style.overflow = "hidden";
        e.preventDefault();
        this.classList.remove('closed');
				const productName = trigger.getAttribute('data-product');
        if (this.productInput) {
          this.productInput.value = productName;
        }
      });
    });
  }

  init() {
    this.handleClose();
    this.handleOpen();
  }
}

if(!customElements.get('product-modal')) {
  customElements.define('product-modal', ProductModal);
}
